import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {Calendar} from '../../models/calendar/calendar';
import {CalendarWeek} from '../../models/calendar/calendarweeks';
import {Week} from '../../models/calendar/week';
const apiUrl = `${environment.apiUrl}/api/week`;

@Injectable({
  providedIn: 'root'
})
export class WeekService {
  constructor(public httpService: HttpClient) { }

  public getAll(year: number): Observable<Week[]> {
    return this.httpService.get<Calendar[]>(`${apiUrl}/getallbyyear/${year}`).pipe(
      map(data => data.map(data => new Week().deserialize(data)))
    );
  }
  public getCurrentWeek()
  {
    return this.httpService.get(`${apiUrl}/getcurrentweek`).pipe(
      map(data => Number(data)));
  }
}
